// src/components/planning/EditSelectionsModal/services/performanceTypeService.ts

import apiClient from '../../../../utils/apiClient';

interface PerformanceTypeResponse {
  performanceTypes: string[];
}

export const searchPerformanceTypes = async (term: string): Promise<string[]> => {
  try {
    const response = await apiClient.get<PerformanceTypeResponse>(
      '/song-selections/search-performance-types',
      { params: { term } }
    );
    return response.data.performanceTypes;
  } catch (error) {
    console.error('Error searching performance types:', error);
    return [];
  }
};